export const ActionsSkeleton = (props) => {
  return (
    <div
      aria-busy={true}
      class="grid gap-3 w-full grid-cols-1 grid-flow-row-dense sm:grid-cols-2 mt-4"
    >
      <div class="animate-pulse bg-gray-200 h-10 rounded leading-10 sm:col-span-2" />
      <div class="animate-pulse bg-gray-200 h-10 rounded leading-10" />
      <div class="animate-pulse bg-gray-200 h-10 rounded leading-10" />
    </div>
  );
};
